"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Item = void 0;
var _react = _interopRequireDefault(require("react"));
var RadioGroup = _interopRequireWildcard(require("@radix-ui/react-radio-group"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _radiogroup = _interopRequireDefault(require("./radiogroup.tokens"));
var _ = require("../..");
var _focus = require("@react-aria/focus");
var _jsxRuntime = require("react/jsx-runtime");
var RadioGroupRoot = (0, _styledComponents.default)(RadioGroup.Root).withConfig({
  displayName: "RadioGroupHandler__RadioGroupRoot",
  componentId: "sc-ccuoln-0"
})(["display:flex;flex-direction:column;gap:", ";"], _radiogroup.default.gap.root);
var RadioGroupItem = (0, _styledComponents.default)(RadioGroup.Item).withConfig({
  displayName: "RadioGroupHandler__RadioGroupItem",
  componentId: "sc-ccuoln-1"
})(["all:unset;background-color:", ";width:", ";height:", ";border-radius:100%;border-style:solid;&[data-state=\"unchecked\"]{border-color:", ";border-width:", ";&:hover{cursor:pointer;}}&[data-state=\"checked\"]{border-color:", ";border-width:", ";&:hover{cursor:default;}}&[data-disabled]{border-color:", ";background-color:", ";&:hover{cursor:default;}}&,&:before,&:after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;}&.focus-ring{box-shadow:", ";}"], _radiogroup.default.background.color.item.default, _radiogroup.default.size.width.item, _radiogroup.default.size.height.item, _radiogroup.default.border.color.item.default, _radiogroup.default.border.width.item.default, _radiogroup.default.border.color.item.selected, _radiogroup.default.border.width.item.selected, _radiogroup.default.border.color.item.disabled, _radiogroup.default.background.color.item.disabled, _radiogroup.default.shadow.item.focusRing);
var RadioGroupIndicator = (0, _styledComponents.default)(RadioGroup.Indicator).withConfig({
  displayName: "RadioGroupHandler__RadioGroupIndicator",
  componentId: "sc-ccuoln-2"
})(["display:flex;align-items:center;justify-content:center;width:100%;height:100%;position:relative;&::after{content:'';display:block;width:", ";height:", ";border-radius:50%;background-color:", ";}&[data-disabled]::after{background-color:", ";}"], _radiogroup.default.size.width.indicator, _radiogroup.default.size.height.indicator, _radiogroup.default.background.color.indicator.active, _radiogroup.default.background.color.indicator.disabled);
var RadioGroupTextContainer = _styledComponents.default.div.withConfig({
  displayName: "RadioGroupHandler__RadioGroupTextContainer",
  componentId: "sc-ccuoln-3"
})(["display:flex;flex-direction:column;align-items:start;justify-content:start;gap:", ";width:100%;"], _radiogroup.default.gap.textContainer);
var Item = function Item(_ref) {
  var children = _ref.children,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, ["children", "value"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
    focusRingClass: "focus-ring",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RadioGroupItem, _objectSpread({
      value: value,
      "aria-label": value
    }, props, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RadioGroupIndicator, {})
    }))
  });
};
exports.Item = Item;
var RadioGroupHandler = function RadioGroupHandler(_ref2) {
  var children = _ref2.children,
    value = _ref2.value,
    _ref2$onValueChange = _ref2.onValueChange,
    onValueChange = _ref2$onValueChange === void 0 ? function () {
      return void 0;
    } : _ref2$onValueChange,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    label = _ref2.label,
    description = _ref2.description;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RadioGroupRoot, {
    value: value,
    onValueChange: onValueChange,
    disabled: disabled,
    children: [(label || description) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(RadioGroupTextContainer, {
      children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.SubHeading, {
        children: label
      }), description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Text, {
        color: 'medium',
        size: '2',
        children: description
      })]
    }), children]
  });
};
RadioGroupHandler.Item = Item;
var _default = exports.default = RadioGroupHandler;